import type { Session } from '@supabase/supabase-js';

export function isAnonymousUser(session: Session | null): boolean {
    if (!session) return false;

    // Check multiple indicators
    return !session.user.email ||
        session.user.email === '' ||
        session.user.app_metadata?.provider === 'anonymous' ||
        session.user.is_anonymous === true;
}

/**
 * A Supabase email session can exist before its address has been confirmed.
 * Treat that intermediate state like signed-out for every private app surface.
 */
export function hasConfirmedEmailIdentity(session: Session | null): boolean {
    if (!session || isAnonymousUser(session)) return false;

    return Boolean(
        session.user.email?.trim()
        && (session.user.email_confirmed_at || session.user.confirmed_at)
    );
}

export function hasUnconfirmedEmailIdentity(session: Session | null): boolean {
    if (!session || isAnonymousUser(session)) return false;

    return Boolean(
        session.user.email?.trim()
        && !session.user.email_confirmed_at
        && !session.user.confirmed_at
    );
}

export function canAccessMainApp(session: Session | null): boolean {
    return hasConfirmedEmailIdentity(session);
}
